import { Component, DestroyRef, ElementRef, HostListener } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TenantPermissions } from '@Core/enums/codegen/tenant-permissions.enum';
import { AuthService } from '@Services/auth.service';
import { AllFeatureFacetsVM, FeatureFacetService } from '@Services/feature-facet.service';
import _ from 'lodash';
import { environment } from 'src/environments/environment';

@Component({
    standalone: false,
    selector: 'ikc-button',
    templateUrl: './ikc-button.component.html',
    styleUrls: ['./ikc-button.component.scss']
})
export class IKCButtonComponent {
    public isIkcMenuOpen: boolean = false;
    public auroraMenuItems: Array<{ id: string; label: string; isGroupHeader?: boolean; isDivider?: boolean }> = [];

    public options: IKCOption[] = [
        {
            Label: 'Underwriting',
            Link: environment.ikcDocumentationUrl,
            Product: 'Underwriting',
        }
    ];

    constructor(
        private authService: AuthService,
        private featureFacetService: FeatureFacetService,
        private destroyRef: DestroyRef,
        private elementRef: ElementRef<HTMLElement>
    ) {}

    ngOnInit() {
        this.featureFacetService.getAllFacets()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((allFacets: AllFeatureFacetsVM) => {
            if (_.some(this.options, o => o.Label === 'Bureau Rating'))
                return;

            if (FeatureFacetService.checkIfFacetExists(TenantPermissions.Flag_Base_Work_Accounts_BureauMode,
                allFacets, this.authService.spaName, this.authService.getAreaKey()
            )) {
                this.options.push({
                    Label: 'Bureau Rating',
                    Link: environment.ikcBureauUrl,
                    Product: 'Bureau Rating',
                });

                this.syncAuroraMenuItems();
            }
        });

        this.syncAuroraMenuItems();
    }

    public toggleAuroraMenu(event: Event): void {
        event.stopPropagation();
        this.isIkcMenuOpen = !this.isIkcMenuOpen;
    }

    public onAuroraMenuItemClick(event: CustomEvent<{ item: { id: string } }>): void {
        const selectedId = event?.detail?.item?.id;
        if (!selectedId) {
            return;
        }

        const selectedOption = this.options.find(option => option.Product === selectedId);
        if (selectedOption) {
            this.clickOption(selectedOption);
        }

        this.isIkcMenuOpen = false;
    }

    public clickOption(option: IKCOption): void {
        if (option && option.Link) {
            window.open(option.Link, '_blank');
        }
    }

    @HostListener('document:click', ['$event'])
    public onDocumentClick(event: Event): void {
        const target = event.target;
        if (!(target instanceof Node)) {
            return;
        }

        if (!this.elementRef.nativeElement.contains(target)) {
            this.isIkcMenuOpen = false;
        }
    }

    private syncAuroraMenuItems(): void {
        this.auroraMenuItems = [
            {
                id: 'ikc-heading',
                label: 'Insurity Knowledge Center',
                isGroupHeader: true
            },
            {
                id: 'ikc-divider',
                label: '',
                isDivider: true
            },
            ...this.options.map(option => ({
                id: option.Product,
                label: option.Label
            }))
        ];
    }
}

export interface IKCOption {
    Link: string;
    Label: string;
    Product: 'Underwriting' | 'Bureau Rating';
}
